export const AddProfileIcon = () => (
  <svg width="100%" height="100%" viewBox="-1 -1 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 11.25H12.75V7H11.25V11.25H7V12.75H11.25V17H12.75V12.75H17V11.25Z" fill="#8C959F" />
    <path
      d="M12 23C5.92487 23 1 18.0751 1 12H-1C-1 19.1797 4.8203 25 12 25V23ZM23 12C23 18.0751 18.0751 23 12 23V25C19.1797 25 25 19.1797 25 12H23ZM12 1C18.0751 1 23 5.92487 23 12H25C25 4.8203 19.1797 -1 12 -1V1ZM12 -1C4.8203 -1 -1 4.8203 -1 12H1C1 5.92487 5.92487 1 12 1V-1Z"
      fill="#AFB8C1"
    />
  </svg>
);
